import React, { useEffect, useState } from 'react';

import { workspaceDetailParams } from 'api';
import { useQuery } from 'hooks';
import { logger } from 'utils';

type WorkspaceProfileContextValue = {
	workspaceProfile: any;
	setWorkspaceProfile: any;
	isCurrentWorkspace: boolean;
	rootApi: string;
	rootLink: string;
	secureApi: string;
	loading: boolean;
	onUpdate: any;
	onRefresh: any;
};

const WorkspaceProfileContext = React.createContext<WorkspaceProfileContextValue>(null);

const WorkspaceProfileProvider = ({ ssr, workspace, router, store, children }) => {
	const [workspaceProfile, setWorkspaceProfile] = useState(ssr.workspaceProfile?.data || {});

	// Computed
	const rootApi = `/workspaces/${workspaceProfile.uuid}`;
	const rootLink = `/${workspaceProfile.uuid}`;
	const secureApi = workspace.rootApi;
	const isCurrentWorkspace = workspace.workspace?.uuid === workspaceProfile.uuid;

	// Hooks
	useEffect(() => {
		return () => onClear();
	}, [router.query.workspaceId]);

	useEffect(() => {
		setWorkspaceProfile(ssr.workspaceProfile?.data || {});
	}, [ssr?.workspaceProfile]);

	useEffect(() => {
		if (workspaceProfile.id) logger.debug('workspaceProfileContext: ', workspaceProfile);
	}, [workspaceProfile]);

	// Actions
	const [fetchData, loading] = useQuery(async () => {
		const response = await store.queryRecord({ url: rootApi, params: workspaceDetailParams });
		setWorkspaceProfile(response.data);
	});

	// Methods
	const onUpdate = data => {
		setWorkspaceProfile({ ...workspaceProfile, ...data });
	};

	const onRefresh = () => fetchData();

	const onClear = () => setWorkspaceProfile({});

	// Render
	return (
		<WorkspaceProfileContext.Provider
			value={{
				workspaceProfile,
				setWorkspaceProfile,
				isCurrentWorkspace,
				rootApi,
				rootLink,
				secureApi,
				loading,
				onUpdate,
				onRefresh,
			}}>
			{children}
		</WorkspaceProfileContext.Provider>
	);
};

const useWorkspaceProfile = () => {
	return React.useContext(WorkspaceProfileContext);
};

export { WorkspaceProfileProvider, useWorkspaceProfile };
